const config = {
    gameIdToName: {
        1: 'val',
        2: 'cs2',
        3: 'df'
    },
    game: {
        val: {
            title: '无畏契约',
            logoSrc: 'https://img.lkval.com/static/assets/val.png',
            maps: {
                abyss: {
                    title: 'ABYSS',
                    chTitle: '幽邃地窟',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/abyss.webp',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/abyssRadar_v2.svg',
                },
                ascent: {
                    title: 'ASCENT',
                    chTitle: '亚海悬城',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/ascent.png',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/ascentRadar.svg',
                },
                bind: {
                    title: 'BIND',
                    chTitle: '源工重镇',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/bind.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/bindRadar.svg',
                },
                breeze: {
                    title: 'BREEZE',
                    chTitle: '微风岛屿',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/breeze.png',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/breezeRadar_v2.svg',
                },
                corrode: {
                    title: 'CORRODE',
                    chTitle: '盐海矿镇',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/corrode.webp',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/corrodeRadar.svg',
                },
                fracture: {
                    title: 'FRACTURE',
                    chTitle: '裂变峡谷',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/fracture.jpg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/fractureRadar.svg',
                },
                haven: {
                    title: 'HAVEN',
                    chTitle: '隐世修所',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/haven.png',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/havenRadar.svg',
                },
                icebox: {
                    title: 'ICEBOX',
                    chTitle: '森寒冬港',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/icebox.png',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/iceboxRadar.svg',
                },
                lotus: {
                    title: 'LOTUS',
                    chTitle: '莲华古城',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/lotus.png',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/lotusRadar.svg',
                },
                pearl: {
                    title: 'PEARL',
                    chTitle: '深海明珠',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/pearl.jpg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/pearlRadar_v2.svg',
                },
                split: {
                    title: 'SPLIT',
                    chTitle: '霓虹町',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/split.png',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/splitRadar.svg',
                },
                sunset: {
                    title: 'SUNSET',
                    chTitle: '日落之城',
                    imgSrc: 'https://img.lkval.com/static/assets/val/map/sunset.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/val/map/sunsetRadar.svg',
                },
            },
            agents: {
                astra: {
                    title: 'Astra',
                    chTitle: '星礈',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/astra.png',
                    background: "background: rgb(255, 21, 218);",
                    color: '#FF15DA',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/astra/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/astra/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/astra/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/astra/4.svg'
                        }
                    }
                },
                breach: {
                    title: 'Breach',
                    chTitle: '铁臂',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/breach.png',
                    background: "background: rgb(220, 177, 144);",
                    color: '#dcb190',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/breach/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/breach/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/breach/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/breach/4.svg'
                        }
                    }
                },
                brimstone: {
                    title: 'Brimstone',
                    chTitle: '炼狱',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/brimstone.png',
                    background: "background: rgb(127, 229, 251);",
                    color: '#7fe5fb',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/brimstone/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/brimstone/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/brimstone/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/brimstone/4.svg'
                        }
                    }
                },
                chamber: {
                    title: 'Chamber',
                    chTitle: '尚勃勒',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/chamber.png',
                    background: "background: rgb(255, 238, 203);",
                    color: '#ffeecb',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/chamber/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/chamber/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/chamber/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/chamber/4.svg'
                        }
                    }
                },
                clove: {
                    title: 'Clove',
                    chTitle: '暮蝶',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/clove.png',
                    background: "background: rgb(208, 202, 243);",
                    color: '#d0caf3',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/clove/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/clove/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/clove/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/clove/4.svg'
                        }
                    }
                },
                cypher: {
                    title: 'Cypher',
                    chTitle: '零',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/cypher.png',
                    background: "background: rgb(204, 206, 193);",
                    color: '#cccec1',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/cypher/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/cypher/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/cypher/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/cypher/4.svg'
                        }
                    }
                },
                deadlock: {
                    title: 'Deadlock',
                    chTitle: '钢锁',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/deadlock.png',
                    background: "background: rgb(222, 229, 225);",
                    color: '#dee5e1',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/deadlock/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/deadlock/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/deadlock/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/deadlock/4.svg'
                        }
                    }
                },
                fade: {
                    title: 'Fade',
                    chTitle: '黑梦',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/fade.png',
                    background: "background: rgb(222, 229, 225);",
                    color: '#dee5e1',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/fade/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/fade/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/fade/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/fade/4.svg'
                        }
                    }
                },
                gekko: {
                    title: 'Gekko',
                    chTitle: '盖可',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/gekko.png',
                    background: "background: rgb(106, 141, 24);",
                    color: '#6a8d18',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/gekko/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/gekko/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/gekko/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/gekko/4.svg'
                        }
                    }
                },
                harbor: {
                    title: 'Harbor',
                    chTitle: '海神',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/harbor.png',
                    background: "background: rgb(143, 202, 255);",
                    color: '#8fcaff',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/harbor/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/harbor/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/harbor/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/harbor/4.svg'
                        }
                    }
                },
                iso: {
                    title: 'Iso',
                    chTitle: '壹决',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/iso.png',
                    background: "background: rgb(213, 161, 255);",
                    color: '#d5a1ff',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/iso/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/iso/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/iso/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/iso/4.svg'
                        }
                    }
                },
                jett: {
                    title: 'Jett',
                    chTitle: '捷风',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/jett.png',
                    background: "background: rgb(118, 207, 221);",
                    color: '#76cfdd',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/jett/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/jett/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/jett/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/jett/4.svg'
                        }
                    }
                },
                kayo: {
                    title: 'Kay/o',
                    chTitle: 'K/O',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/kayo.png',
                    background: "background: rgb(127, 229, 251);",
                    color: '#7fe5fb',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/kayo/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/kayo/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/kayo/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/kayo/4.svg'
                        }
                    }
                },
                killjoy: {
                    title: 'Killjoy',
                    chTitle: '奇乐',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/killjoy.png',
                    background: "background: rgb(50, 205, 50);",
                    color: '#32cd32',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/killjoy/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/killjoy/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/killjoy/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/killjoy/4.svg'
                        }
                    }
                },
                neon: {
                    title: 'Neon',
                    chTitle: '霓虹',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/neon.png',
                    background: "background: rgb(213, 255, 252);",
                    color: '#d5fffc',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/neon/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/neon/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/neon/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/neon/4.svg'
                        }
                    }
                },
                omen: {
                    title: 'Omen',
                    chTitle: '幽影',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/omen.png',
                    background: "background: rgb(127, 229, 251);",
                    color: '#7fe5fb',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/omen/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/omen/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/omen/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/omen/4.svg'
                        }
                    }
                },
                phoenix: {
                    title: 'Phoenix',
                    chTitle: '不死鸟',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/phoenix.png',
                    background: "background: rgb(243, 142, 94);",
                    color: '#f38e5e',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/phoenix/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/phoenix/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/phoenix/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/phoenix/4.svg'
                        }
                    }
                },
                raze: {
                    title: 'Raze',
                    chTitle: '雷兹',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/raze.png',
                    background: "background: rgb(234, 189, 116);",
                    color: '#eabd74',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/raze/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/raze/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/raze/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/raze/4.svg'
                        },
                        5: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/raze/5.svg'
                        }
                    }
                },
                reyna: {
                    title: 'Reyna',
                    chTitle: '芮娜',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/reyna.png',
                    background: "background: rgb(186, 21, 173);",
                    color: '#ba15ad',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/reyna/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/reyna/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/reyna/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/reyna/4.svg'
                        }
                    }
                },
                sage: {
                    title: 'Sage',
                    chTitle: '贤者',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/sage.png',
                    background: "background: rgb(102, 230, 217);",
                    color: '#66e6d9',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sage/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sage/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sage/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sage/4.svg'
                        }
                    }
                },
                skye: {
                    title: 'Skye',
                    chTitle: '斯凯',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/skye.png',
                    background: "background: rgb(144, 170, 117);",
                    color: '#90aa75',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/skye/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/skye/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/skye/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/skye/4.svg'
                        }
                    }
                },
                sova: {
                    title: 'Sova',
                    chTitle: '猎枭',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/sova.png',
                    background: "background: rgb(127, 229, 251);",
                    color: '#7fe5fb',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sova/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sova/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sova/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sova/4.svg'
                        },
                        5: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/sova/5.svg'
                        }
                    }
                },
                tejo: {
                    title: 'Tejo',
                    chTitle: '钛狐',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/tejo.png',
                    background: "background: rgb(250, 201, 125);",
                    color: '#fac97d',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/tejo/1.png'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/tejo/2.webp'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/tejo/3.webp'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/tejo/4.webp'
                        },
                    }
                },
                veto: {
                    title: 'Veto',
                    chTitle: '禁灭',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/veto.png',
                    background: "background: rgb(53, 182, 212);",
                    color: '#35b6d4',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/veto/1.png'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/veto/2.webp'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/veto/3.webp'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/veto/4.webp'
                        },
                    }
                },
                viper: {
                    title: 'Viper',
                    chTitle: '蝰蛇',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/viper.png',
                    background: "background: rgb(87, 217, 72);",
                    color: '#57d948',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/viper/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/viper/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/viper/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/viper/4.svg'
                        }
                    }
                },
                vyse: {
                    title: 'Vyse',
                    chTitle: '维斯',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/vyse.png',
                    background: "background: rgb(159, 116, 179);",
                    color: '#9f74b3',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/vyse/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/vyse/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/vyse/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/vyse/4.svg'
                        }
                    }
                },
                waylay: {
                    title: 'Waylay',
                    chTitle: '幻棱',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/waylay.png',
                    background: "background: rgb(170, 66, 255);",
                    color: '#aa42ff',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/waylay/1.png'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/waylay/2.png'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/waylay/3.png'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/waylay/4.png'
                        }
                    }
                },
                yoru: {
                    title: 'Yoru',
                    chTitle: '夜露',
                    imgSrc: 'https://img.lkval.com/static/assets/val/agent/yoru.png',
                    background: "background: rgb(127, 229, 251);",
                    color: '#7fe5fb',
                    ability: {
                        1: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/yoru/1.svg'
                        },
                        2: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/yoru/2.svg'
                        },
                        3: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/yoru/3.svg'
                        },
                        4: {
                            imgSrc: 'https://img.lkval.com/static/assets/val/agent/yoru/4.svg'
                        }
                    }
                },
            },
            leaflet: {
                addLineup: {
                    point: {
                        radius: 10,
                        startPointFillColor: '#00FF00',
                        endPointFillColor: '#FFFF00',
                    },
                    polygon: {
                        color: 'red',
                        weight: 1,
                    }
                },
                showLineup: {
                    togetherDistance: 14,
                    abilityImgSize: 40,
                    agentImgSize: 50,
                    agentCircle: {
                        radius: 30,
                        weight: 0,
                        fillOpacity: 1,
                    },
                    endCircle: {
                        radius: 30,
                        fillColor: '#C8D0CF',
                        fillOpacity: 0.2,
                        weight: 0,
                    },
                    endCircleMouseOver: {
                        radius: 40,
                        color: '#3388ff',
                        weight: 1,
                    },
                    polygon: {
                        color: 'red',
                        weight: 1,
                        fillOpacity: 0.3,
                    },
                    polylineWithEndPoint: {
                        color: 'yellow',
                        weight: 2,
                    },
                    startEndLine: {
                        color: '#ffffff',
                        weight: 1,
                    },
                    startEndLineMouseOver: {
                        color: '#ffcc00',
                        weight: 2,
                    },
                },
                mouseover: {
                    polylineWithEndPoint: {
                        color: 'red',
                        weight: 2,
                    }
                }
            },
        },
        cs2: {
            title: 'CS2',
            logoSrc: 'https://img.lkval.com/static/assets/cs2.png',
            maps: {
                dust2: {
                    title: 'Dust2',
                    chTitle: '炙热沙城Ⅱ',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/dust2.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/dust2Radar.webp',
                },
                inferno: {
                    title: 'Inferno',
                    chTitle: '炼狱小镇',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/inferno.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/infernoRadar.webp',
                },
                mirage: {
                    title: 'Mirage',
                    chTitle: '荒漠迷城',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/mirage.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/mirageRadar.webp',
                },
                ancient: {
                    title: 'Ancient',
                    chTitle: '远古遗迹',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/ancient.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/ancientRadar.webp',
                },
                anubis: {
                    title: 'Anubis',
                    chTitle: '阿努比斯',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/anubis.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/anubisRadar.webp',
                },
                nuke: {
                    title: 'Nuke',
                    chTitle: '核子危机',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/nuke.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/nukeRadar.png',
                },
                vertigo: {
                    title: 'Vertigo',
                    chTitle: '殒命大厦',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/vertigo.jpeg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/vertigoRadar.webp',
                },
                overpass: {
                    title: 'Overpass',
                    chTitle: '死亡游乐园',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/overpass.jpg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/overpassRadar.webp',
                },
                train: {
                    title: 'Train',
                    chTitle: '列车停放站',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/map/train.jpg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/trainRadar.webp',
                }
            },
            ability: {
                1: {
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Smoke.png'
                },
                2: {
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Molly.png'
                },
                3: {
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Hegrenade.png'
                },
                4: {
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Flashbang.png'
                },
                5: {
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Trick.png',
                }
            },
            side: {
                1: {
                    title: 'T',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/side/side_t.png',
                },
                2: {
                    title: 'CT',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/side/side_ct.png',
                },
                0: {
                    title: 'Both',
                    imgSrc: 'https://img.lkval.com/static/assets/cs2/side/side_both.png',
                }
            },
            leaflet: {
                addLineup: {
                    point: {
                        radius: 10,
                        startPointFillColor: '#00FF00',
                        endPointFillColor: '#FFFF00',
                    },
                },
                showLineup: {
                    agentImgSize: 70,
                    togetherDistance: 14,
                    togetherLineup: {
                        countCircle: {
                            radius: 18,
                            circleColor: '#FFFFFF',
                        },
                    },
                    abilityImgSize: 60,
                    endCircleMouseOver: {
                        radius: 40,
                        color: '#ffffff',
                        weight: 2,
                    },
                    endCircle: {
                        radius: 35,
                        fillColor: '#2a2c31',
                        fillOpacity: 1,
                        weight: 0,
                    },
                    agentCircle: {
                        radius: 30,
                        weight: 1,
                        fillColor: '#000000',
                        fillOpacity: 0.5,
                        color: '#ffcc00',
                    },
                    agentRectangle: {
                        sideLength: 40,
                        color: "#00FF00",
                        weight: 1,
                        fillOpacity: 0.2,
                    },
                    agentRectangleMouseOver: {
                        sideLength: 40,
                        color: "#00FF00",
                        weight: 1,
                        fillOpacity: 1,
                    },
                    agentCircleMouseOver: {
                        radius: 40,
                        weight: 1,
                        fillColor: '#ffcc00',
                        fillOpacity: 1,
                        color: '#ffcc00',
                    },
                    startEndLine: {
                        color: '#ffffff',
                        weight: 1,
                    },
                    startEndLineMouseOver: {
                        color: '#ffcc00',
                        weight: 2,
                    },
                }
            }
        },
        df: {
            title: '三角洲行动',
            logoSrc: 'https://img.lkval.com/static/assets/df.jpg',
            maps: {
                lhdb: {
                    title: 'lhdb',
                    chTitle: '零号大坝',
                    imgSrc: 'https://img.lkval.com/static/assets/df/map/lhdb.jpg',
                    radarImgSrc: 'https://img.lkval.com/static/assets/df/map/lhdbRadar.jpg',
                },
                bks: {
                    title: 'bks',
                    chTitle: '巴克什',
                    imgSrc: 'https://img.lkval.com/static/assets/df/map/bks.webp',
                    radarImgSrc: 'https://img.lkval.com/static/assets/df/map/bksRadar.jpg',
                },
                htjd: {
                    title: 'htjd',
                    chTitle: '航天基地',
                    imgSrc: 'https://img.lkval.com/static/assets/df/map/htjd.webp',
                    radarImgSrc: 'https://img.lkval.com/static/assets/df/map/htjdRadar.jpg',
                },

            },
            ability: {
                imgSrc: {
                    yellow: 'https://img.lkval.com/static/assets/YellowPoint.png',
                    red: 'https://img.lkval.com/static/assets/RedPoint.png',
                }
            },
            agents: {
                general: {
                    title: 'general',
                    chTitle: '',
                    imgSrc: 'https://img.lkval.com/static/assets/df/agent/general.jpg',
                },
                luna: {
                    title: 'luna',
                    chTitle: '露娜',
                    imgSrc: 'https://img.lkval.com/static/assets/df/agent/luna_v2.jpg',
                },
                weilong: {
                    title: 'weilong',
                    chTitle: '威龙',
                    imgSrc: 'https://img.lkval.com/static/assets/df/agent/weilong_v2.jpg',
                },
                jifeng: {
                    title: 'jifeng',
                    chTitle: '疾风',
                    imgSrc: 'https://img.lkval.com/static/assets/df/agent/jifeng.jpg',
                },
                honglang: {
                    title: 'honglang',
                    chTitle: '红狼',
                    imgSrc: 'https://img.lkval.com/static/assets/df/agent/honglang.jpg',
                },
                fengyi: {
                    title: 'fengyi',
                    chTitle: '蜂医',
                    imgSrc: 'https://img.lkval.com/static/assets/df/agent/fengyi.jpg',
                }
            },
            leaflet: {
                addLineup: {
                    point: {
                        radius: 10,
                        startPointFillColor: '#00FF00',
                        endPointFillColor: '#FFFF00',
                    },
                    polygon: {
                        color: 'red',
                        weight: 1,
                    }
                },
                showLineup: {
                    abilityImgSize: 60,
                    agentImgSize: 50,
                    endCircleMouseOver: {
                        radius: 40,
                        color: '#3388ff',
                        weight: 1,
                    },
                },
            },
        }
    },
    side: {
        0: {
            title: '全部',
        },
        1: {
            title: '进攻',
        },
        2: {
            title: '防守',
        }
    },
    povUpNameList: ['清汤烧', '染歌', '22林酱', '波洛落萝', 'Lff']
}

export {config}